module.exports = __webpack_public_path__ + "img/PhotoExhibit-Ecuador.115ecd1a.jpg";